import { getFirstSelection } from '../../selectionUtils/tableSelectionAccessors';
import { isSelectingSingleSelection } from '../../selectionUtils/tableSelectionPredicateUtils';
import { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Adds a formula to the currently selected cell in the Handsontable instance.
 */
export const addHotTableFormulaToCell = (hotInstance: MNHotInstance, cellSelections = hotInstance.getSelected()) => {
    if (!cellSelections) return;

    if (!isSelectingSingleSelection(cellSelections)) return;

    const cellSelection = getFirstSelection(cellSelections);
    if (!cellSelection) return;

    requestAnimationFrame(() => {
        if (hotInstance.isDestroyed) return;

        // Restore focus to the cell before starting the editor (the toolbar click will have blurred it)
        hotInstance.selectCell(...cellSelection, false, true);

        hotInstance.getActiveEditor()?.beginEditing('=');
    });
};
